import { generateText as generateTextAi, streamText as streamTextAi } from 'ai'
import { aiModelsSchema, getAIModel } from './schema/providers.js'

type GenerateText = Omit<Parameters<typeof generateTextAi>[0], 'model'> & {
  type: 'client' | 'server'
  apiKey: string
  modelName: string
}

/** Thin wrapper around AI SDK generate text  */
export const generateText = async ({ apiKey, modelName, type = 'server', ...restProps }: GenerateText) => {
  const model = getAIModel({ type, authToken: apiKey, model: aiModelsSchema.parse(modelName) })

  return generateTextAi({ model, ...restProps })
}

type StreamText = Omit<Parameters<typeof streamTextAi>[0], 'model'> & {
  apiKey: string
  type: 'client' | 'server'
  modelName: string
}

export const streamText = ({ apiKey, type = 'server', modelName, ...restProps }: StreamText) => {
  const model = getAIModel({ type, authToken: apiKey, model: aiModelsSchema.parse(modelName) })

  return streamTextAi({ model, ...restProps })
}
